export default from './EmbedSurveyPage';



// WEBPACK FOOTER //
// ./src/components/EmbedSurveyPage/index.js